module.exports = __webpack_public_path__ + "static/img/msgz.058c9735.png";